import { useSelector } from 'react-redux';
import { enableVariantBufferBySupplier, enableVariantBufferByUser } from '../constants/featureFlag';
import { useFeatureFlag } from './useFeatureFlag';
import { getAuthorizedUsersAndSuppliersForFeatureFlag } from '../utils/user-based-feature-flag';

/*
 when at least one FF is enabled, we enable for all users & suppliers.
 when both FF's are disabled, we check for the values in the array.
*/

export function useBufferByVariant() {
  const currentUser = useSelector((state) => state.role.user);
  const currentSupplierId = useSelector((state) => state.role.supplierId);

  const isEnabledForAllUsers = useFeatureFlag(enableVariantBufferByUser, false, true);
  const isEnabledForAllSuppliers = useFeatureFlag(enableVariantBufferBySupplier, false, true);

  const permittedEmails = useFeatureFlag(enableVariantBufferByUser, JSON.stringify([]));
  const permittedSuppliers = useFeatureFlag(enableVariantBufferBySupplier, JSON.stringify([]));

  if (isEnabledForAllUsers || isEnabledForAllSuppliers) {
    return {
      isAllowedByEmail: true,
      isAllowedBySupplierId: true,
    };
  }

  return getAuthorizedUsersAndSuppliersForFeatureFlag({
    featureFlagEmailBasedValue: permittedEmails,
    userEmail: currentUser?.email,
    featureFlagSupplierBasedValue: permittedSuppliers,
    supplierId: currentSupplierId,
  });
}
